var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-pre-box",on:{"click":function($event){return _vm.imgClose('close')}}},[_c('img',{staticClass:"u-img-pre",attrs:{"src":_vm.imgUrl,"alt":"图片资料"}})])}
var staticRenderFns = []

export { render, staticRenderFns }